import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';

import CustomIcon from '../../common/CustomIcon';
import BookDownloadBar from '../../book/BookDownloadBar/BookDownloadBar';
import BookCardCommon from './BookCardCommon';

import * as contentActions from '../../../actions/contentActions';
import * as bookActions from '../../../actions/bookActions';

import { getBookNameFromBookActivity } from '../../../services/domain/bookService';
import { BOOK_DOWNLOADING_STATUS } from '../../../const';
import * as contentUtils from '../../../utils/contentUtils';

class BookCardElectron extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleSaveBook = this.handleSaveBook.bind(this);
    this.handleReDownloadButton = this.handleReDownloadButton.bind(this);
    this.renderLoadBar = this.renderLoadBar.bind(this);
    this.renderSavedBookIcon = this.renderSavedBookIcon.bind(this);
    this.handleSwitchDownloadButton = this.handleSwitchDownloadButton.bind(this);

    this.state = {
      title: getBookNameFromBookActivity(this.props.book)
    };
  }

  componentDidUpdate(prevProps) {
    const { book } = this.props;
    const { title } = this.state;

    let newBookTitle = getBookNameFromBookActivity(book);
    if (newBookTitle !== title) {
      this.setState({ title: newBookTitle });
    }
  }

  static propTypes = {
    book: PropTypes.object,
    contentActions: PropTypes.object,
    bookActions: PropTypes.object,
    classroom: PropTypes.string,
    contentBooks: PropTypes.object
  };

  handleSaveBook() {
    const { book, contentActions, classroom } = this.props;
    const { title } = this.state;
    contentActions.saveBook(classroom, book, title);
  }

  handleReDownloadButton() {
    const { book, bookActions } = this.props;
    bookActions.setReDownloadBookState(book);
  }

  handleSwitchDownloadButton() {
    const { book, contentActions, classroom } = this.props;
    const { title } = this.state;

    if (this.isDownloadOnPause()) {
      contentActions.saveBook(classroom, book, title);
    } else {
      contentActions.updateContentBookStatus(BOOK_DOWNLOADING_STATUS.PAUSE, book.activityId, classroom);
    }
  }

  isDownloading() {
    const { book, contentBooks } = this.props;
    return contentUtils.isStoreContentBookDownloading(book, contentBooks);
  }

  isSaving() {
    const { book, contentBooks } = this.props;
    return contentUtils.isStoreContentBookSaving(book, contentBooks);
  }

  isDownloaded() {
    const { book, contentBooks } = this.props;
    return contentUtils.isStoreContentBookDownloaded(book, contentBooks);
  }

  isDownloadOnPause() {
    const { book, contentBooks } = this.props;
    return contentUtils.isStoreContentBookPaused(book, contentBooks);
  }

  renderLoadBar() {
    const { book, classroom } = this.props;

    return <BookDownloadBar bookId={book.id} classId={classroom} wrapperClassName={'load-bar-book-wrapper'} />;
  }

  renderSavedBookIcon() {
    const isBookContentDownloaded = this.isDownloaded();

    if (isBookContentDownloaded) {
      return (
        <div className="save-book-icon">
          <CustomIcon size={20} name="download-tray" />
        </div>
      );
    }
  }

  renderDownloadButton() {
    return [
      {
        position: 2,
        option: {
          id: 4,
          name: I18n.t('common.option.download'),
          action: this.handleSaveBook,
          class: '',
          icon: <CustomIcon name="download-tray" size={16} />,
          disabledOffline: true
        }
      }
    ];
  }

  renderReDownloadButton() {
    return [
      {
        position: 2,
        option: {
          id: 4,
          name: I18n.t('common.option.reDownload'),
          action: this.handleReDownloadButton,
          class: '',
          icon: <CustomIcon name="download-tray" size={16} />,
          disabledOffline: true
        }
      }
    ];
  }

  /* renderSwitchDownloadButton() {
    const downloadOnPause = this.isDownloadOnPause();

    const name = downloadOnPause ? I18n.t('common.option.resume') : I18n.t('common.option.pause');
    const customIconName = downloadOnPause ? 'play-video' : 'video-player-pause-button';

    return [{
      position: 2,
      option: {
        id: 4,
        name,
        action: this.handleSwitchDownloadButton,
        class: '',
        icon: <CustomIcon name={customIconName} size={16}/>,
        disabledOffline: false
      }
    }];
  } */

  getElectronMenuOptions() {
    // TODO: add pause feature
    const isBookContentDownloaded = this.isDownloaded();
    const isBookContentSaving = this.isSaving();
    // const isBookContentDownloading = this.isDownloading();

    const isBookDownloadable = !isBookContentDownloaded && !isBookContentSaving;
    const isBookReDownloadable = isBookContentDownloaded && !isBookContentSaving;
    // const isBookDownloading = !isBookContentDownloaded && isBookContentDownloading;

    if (isBookDownloadable) return this.renderDownloadButton();
    if (isBookReDownloadable) return this.renderReDownloadButton();
    // if (isBookDownloading) return this.renderSwitchDownloadButton();
  }

  render() {
    let { book, classroom } = this.props;
    const extraMenuOptions = this.getElectronMenuOptions();

    return (
      <BookCardCommon
        book={book}
        classroom={classroom}
        renderLoadBar={this.renderLoadBar}
        extraMenuOptions={extraMenuOptions}
        renderSavedBookIcon={this.renderSavedBookIcon()}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    contentBooks: state.content.contentBooks
  };
}

function mapDispatchToProps(dispatch) {
  return {
    contentActions: bindActionCreators(contentActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookCardElectron);
